import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { RootState } from 'store';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_EXTRA_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState?.() as RootState)?.user?.token;

    if (token) {
      headers?.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const baseApi = createApi({
  baseQuery,
  endpoints: () => ({}),
});
